module.exports = __webpack_public_path__ + "assets/img/kv-9459f48f.png";